import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import SeasonalBanner from './components/SeasonalBanner';
import Hero from './components/Hero';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PastriesPage from './pages/PastriesPage';
import PatesPage from './pages/PatesPage';
import HistoryPage from './pages/HistoryPage';
import LegalPage from './pages/LegalPage';
import { LanguageProvider } from './LanguageContext';
import { Toaster } from './components/ui/toaster';

const Home = () => (
  <>
    <SeasonalBanner />
    <Navbar />
    <Hero />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-[#f6ecd9] text-[#0d1b36] min-h-screen overflow-x-hidden">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nos-patisseries" element={<PastriesPage />} />
            <Route path="/nos-pates" element={<PatesPage />} />
            <Route path="/notre-histoire" element={<HistoryPage />} />
            <Route path="/mentions-legales" element={<LegalPage type="mentions" />} />
            <Route path="/confidentialite" element={<LegalPage type="confidentialite" />} />
            <Route path="/cgv" element={<LegalPage type="cgv" />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
